import React, { createContext, useContext, useState } from "react";

const HeaderContext = createContext();

export const useHeaderContext = () => useContext(HeaderContext);

export const HeaderProvider = ({ children }) => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [headerAlert, setHeaderAlert] = useState(false);

  return (
    <HeaderContext.Provider value={{ headerHeight, setHeaderHeight, headerAlert, setHeaderAlert }}>
      {children}
    </HeaderContext.Provider>
  );
};
